import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  IconButton,
  TextField,
  Typography,
  CircularProgress,
  Tooltip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import InfoIcon from "@mui/icons-material/Info";
import {
  useUploadSkusImportados,
  useUploadSkusNormais,
} from "../../../client/hooks/marketplace/marketplace.queries";

// Componente de Upload de Arquivo com Ícone de Informação
const FileUploadComponent = ({
  label,
  file,
  setFile,
  uploadHook,
  onOpenHelp,
}) => {
  const [uploading, setUploading] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);

  const handleUpload = (event) => {
    const selectedFile = event.target.files[0];

    if (selectedFile) {
      setFile(selectedFile);
    }
  };

  const { isLoading } = uploadHook(selectedFile, uploading);

  useEffect(() => {
    if (!isLoading && uploading) {
      setUploading(false);
    }
  }, [isLoading, uploading]);

  return (
    <Box display="flex" flexDirection="column">
      <Box display="flex" alignItems="center" sx={{ mb: 1, ml: 4 }}>
        <Typography sx={{ width: "25%" }}>{label}</Typography>
        <Tooltip title="Ajuda formato do CSV">
          <IconButton onClick={onOpenHelp} size="small">
            <InfoIcon color="primary" />
          </IconButton>
        </Tooltip>
      </Box>

      <Box
        display="flex"
        flexDirection="row"
        gap={1}
        mb={1}
        alignItems="center"
        sx={{ justifyContent: "center" }}
      >
        <TextField
          value={file ? file.name : "Nenhum arquivo selecionado"}
          size="small"
          disabled
          sx={{ width: "65%" }}
        />
        <Button
          component="label"
          variant="outlined"
          sx={{
            height: "42px",
            fontWeight: 600,
            textTransform: "none",
            backgroundColor: "#fdf0e3", // tom suave
            color: "#ff7655",
            border: "1px solid #fdf0e3",
            "&:hover": {
              backgroundColor: "#ffe4d8", // hover um pouco mais forte
              color: "#ff5722", // tom mais intenso
              borderColor: "#ff5722",
            },
          }}
        >
          Sel Arquivo
          <input type="file" accept=".csv" hidden onChange={handleUpload} />
        </Button>
        {file && (
          <IconButton
            onClick={() => setFile(null) && setSelectedFile(null)}
            color="error"
          >
            <DeleteIcon />
          </IconButton>
        )}
      </Box>
      {isLoading && <CircularProgress size={24} sx={{ mt: 1 }} />}
    </Box>
  );
};

// Componente de Upload de Arquivos do E-commerce
const EcommerceFileUpload = ({ onFilesSelected }) => {
  const [skusImportados, setSkusImportados] = useState(null);
  const [skusNormais, setSkusNormais] = useState(null);
  const [helpOpen, setHelpOpen] = useState(false); // Estado para abrir o Dialog de ajuda

  useEffect(() => {
    setSkusImportados(null);
    setSkusNormais(null);
  }, []);

  useEffect(() => {
    if (skusImportados || skusNormais) {
      onFilesSelected(skusImportados, skusNormais);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [skusImportados, skusNormais]);

  return (
    <Box display="flex" justifyContent="center" flexDirection="column">
      <FileUploadComponent
        label="Skus Importados"
        file={skusImportados}
        setFile={setSkusImportados}
        uploadHook={useUploadSkusImportados}
        onOpenHelp={() => setHelpOpen(true)}
      />
      <FileUploadComponent
        label="Skus Normais"
        file={skusNormais}
        setFile={setSkusNormais}
        uploadHook={useUploadSkusNormais}
        onOpenHelp={() => setHelpOpen(true)}
      />

      {/* Diálogo de Ajuda sobre Formato CSV */}
      <Dialog
        open={helpOpen}
        onClose={() => setHelpOpen(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>
          Modelo de como deve ser o arquivo para o funcionamento correto
        </DialogTitle>
        <DialogContent>
          <Box display="flex" justifyContent="center">
            <img
              src={require("../../../assets/ExCsv.png")}
              alt="Formato do CSV"
              style={{ maxWidth: "100%", height: "auto" }}
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setHelpOpen(false)} color="primary">
            Fechar
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default EcommerceFileUpload;
